import { Button, Col, Form, Row, Select } from "antd";
import React from "react";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import MultiSelect from "../../../components/common/MultiSelect";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import { MdEmail } from "react-icons/md";

import "./ResidentForms.css";
import { status, tenants } from "../../../data/residentForms";
import { Propertiesunitscampaigns } from "../../../data/renewals";

const ResidentFormsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("PDF Form Templates", "1", "", "", "/leasing/leases/pdf-form-templates"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("PDF Form Templates", "2", "", "", "/leasing/leases/pdf-form-templates")]
  ),
];

function ResidentForms() {
  return (
    <>
      <div className="resident-forms">
        <PageHeading heading="Resident Forms" />
        <div className="resident-forms-container">
        <Row justify="space-between" align="middle" className="new-container">
          <Col>
            <Row gutter={[24, 0]} align="middle">
              <Col>
                <h3>New</h3>
              </Col>
              <Col>
                <p>Tracking Resident Forms</p>
                <p>
                  You can now preview, reprint, countersign, and upload
                  completed Resident Forms you've sent out, all on one page.
                </p>
              </Col>
            </Row>
          </Col>
          <Col>
            <button className="icon-btn">
              <MdEmail size={16} /> <span>Feed Back</span>{" "}
            </button>
          </Col>
        </Row>
        <Form layout="vertical">
          <Row gutter={[16,0]}>
            <Col span={8}>
              <Form.Item label="Tenant">
                <Select options={[]} placeholder="Search by Tenant"/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Properties or Units">
                <MultiSelect options={[]} placeholder="Search by unit, property or group"/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Status">
                <MultiSelect options={[]} placeholder="Search by Status" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row><Col><Button >Clear Filters</Button></Col></Row>
        <Row className="filtered-data-container" justify="center">
          <Col ><p>No resident forms found. Try adjusting or clearing the filters.</p></Col>
        </Row>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ResidentFormsRightBar} />
      </div>
    </>
  );
}

export default ResidentForms;
